   import { Component, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort,DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { Observable } from 'rxjs/Rx';
import { startWith, map } from 'rxjs/operators';
import { FormControl, FormGroup} from '@angular/forms';
import { DatePipe} from "@angular/common";
import Swal from "sweetalert2";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesTitles, MessagesGeneral, MessagesDates } from '../../../models/messages';
import { SolicitudDesembolsoService } from '../../../services/operaciones/solicitud-desembolso/solicitud-des.service';
import { FiltrosDesembolso } from 'app/models/FiltrosDesembolso';
import { DesembolsoService } from 'app/services/tesoreria/desembolso/desembolso.service';
import 'rxjs/add/observable/of';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { environment } from 'environments/environment';

export const MY_FORMATS = {
    parse: {
      dateInput: "DD-MM-YYYY"
    },
    display: {
      dateInput: "DD-MM-YYYY",
      monthYearLabel: "MMM YYYY",
      dateA11yLabel: "DD-MM-YYYY",
      monthYearA11yLabel: "MMMM YYYY"
    }
};

declare var $: any;
@Component({
    selector: 'app-listado-desembolso',
    templateUrl: './listado-desembolso.component.html',
    styleUrls: ['./listado-desembolso.component.scss'],
    animations: [
      trigger('detailExpand', [
        state('collapsed', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
        state('expanded', style({ height: '*', visibility: 'visible' })),
        transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
      ]),
    ],
    providers: [MessagesTitles,MessagesGeneral,MessagesDates,
      DatePipe,
    
      {
        provide: DateAdapter,
        useClass: MomentDateAdapter,
        deps: [MAT_DATE_LOCALE]
      },
  
      { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    ]
})


export class ListadoDesembolsoComponent{

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  
    loading:boolean;
    data :any = [];
    idDesembolso: number = 0;
    fechaD: Date = new Date();
    fechaH: Date = new Date();

    flagDesembolsoDetalle:boolean = false;
  
    ane:any=[];
    user:any;

    ruc = new FormControl();
    rucAdq = new FormControl();
      
    idProv;
    idAdq;
    activador : number;
    form : FormGroup;
    formA: FormGroup;
    TipoMoneda : any = [];
    proveedoresArr;
    adquirentesArr;
    filteredProveeedor: Observable<any[]>;
    filteredAdquirentes: Observable<any[]>;
    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
    @ViewChild(MatSort, {static: true}) sort: MatSort;
    pageSizeOptions = [15,20,30,50,100,200];
    displayedColumns = ['checked','idDesembolso','Fecha_Planilla','Codigo_Planilla','Tipo_de_planilla_Descp','Moneda_Planilla','Importe','Estado_Descp','Fecha_Aprobacion','Fecha_Confirmacion','Fecha_real_desembolso'];
    dataSourceDetalle : any;
    dataSource: MatTableDataSource<any>;

    isExpansionDetailRow = (i: number, row: Object) => {
      return row.hasOwnProperty('detailRow');
    } 

    expandedElement: any;
    DTOFiltrosDesembolso: FiltrosDesembolso = new FiltrosDesembolso();

    constructor(
      private desembolsoService:DesembolsoService,
        private datePipe:DatePipe,
        private solicitudDesembolsoService:SolicitudDesembolsoService){

      this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    
      this.fechaD.setDate(this.fechaD.getDate()-60);
      this.ObtenerProveedorCombo();
      this.ObtenerAdquirentesCombo();
    }

    ngOnInit(){ 
      this.DTOFiltrosDesembolso.Tipo = 524 ;
      this.ListadoDesembolsoFiltro();
    }

    tipoMoneda(event){
      if(event==''){
        this.DTOFiltrosDesembolso.Moneda=0;
      }else{
        this.DTOFiltrosDesembolso.Moneda = event;
      }      
    }
    tipoPlanilla(event){
      this.DTOFiltrosDesembolso.Tipo = event;
    }

  getRows(){

    //solo es modelo
    this.DTOFiltrosDesembolso.IdProv = "";
    this.DTOFiltrosDesembolso.IdAd = "";

    this.desembolsoService.FiltroListadoDesembolso(this.DTOFiltrosDesembolso,this.datePipe.transform(this.fechaD,'yyyy-MM-dd'),this.datePipe.transform(this.fechaH,'yyy-MM-dd')).
    subscribe(
        res =>{
          const Lista : any = res;
          const rows = [];

          Lista.forEach(obj => {
            let a = this.data.filter(object => object.idDesembolso == obj.idDesembolso);
            if (a.length === 0){
              this.data.push(obj); 
            }
          });
            
          this.data.forEach(elemento => {
            let element : any = Lista.filter(elem => elem !== undefined && elem.idDesembolso === elemento.idDesembolso)
            rows.push(elemento, { detailRow: true,element })
            }
          );

          this.dataSource = new MatTableDataSource(rows);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
        }
      );
  }

  toggleRow(value,event,checked) {
    const foundElement = this.dataSource.data.find(elem => elem.element !== undefined && elem.element[0].idDesembolso === value.idDesembolso)
    this.dataSourceDetalle = new MatTableDataSource(foundElement.element); 
    const index = this.dataSource.data.indexOf(foundElement);
    this.dataSource.data[index].element.show = !this.dataSource.data[index].element.show;
    if(checked){
      event.target.classList.remove('fa-angle-double-up');
      event.target.classList.add('fa-angle-double-down');
    } else {
      event.target.classList.remove('fa-angle-double-down');
      event.target.classList.add('fa-angle-double-up');
    }
  }

  private _filterProv(value:string):any[]{
    const filterValue = value.toString().toLowerCase();
    return this.proveedoresArr.filter(
        filtro => filtro.Razon_Social.toLowerCase().includes(filterValue) === true
    )
  }

  ObtenerProveedorCombo(){
    this.proveedoresArr = JSON.parse(sessionStorage.getItem('lstProvCbo'));
    this.filteredProveeedor = this.ruc.valueChanges
    .pipe(
        startWith(""),
        map(stat =>
            stat ? this._filterProv(stat) : this.proveedoresArr.slice()
        )
    );
  }
  
  obtenerIdProv(termino:string){
    this.idProv = termino;
    this.DTOFiltrosDesembolso.IdProv = termino;
  }

  EnteroObtenerRucRazSocialProv(termino:string = ''){
    if(termino != null && termino != ''){
      let termino1 = termino.toLowerCase();
      for(let p of this.proveedoresArr){
          let raz = p.Razon_Social.toLocaleLowerCase();
        if(raz.indexOf(termino1) >=0){
          this.idProv = p.idEmpresa;
          this.DTOFiltrosDesembolso.IdProv = p.idEmpresa;
        }
      }
    }
 }

  private _filterAdq(value:string):any[]{
  const filterValue = value.toString().toLowerCase();
  return this.adquirentesArr.filter(
    filtroA => filtroA.Razon_Social.toLowerCase().includes(filterValue) === true
  )
  }

  ObtenerAdquirentesCombo() {
    this.adquirentesArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));   
    this.filteredAdquirentes = this.rucAdq.valueChanges
    .pipe(
      startWith(""),
      map(states =>
        states ? this._filterAdq(states) : this.adquirentesArr.slice()
      )
    );
  }

  obtenerIdAd(terminoAD :string){
    this.idAdq = terminoAD;
    this.DTOFiltrosDesembolso.IdAd = terminoAD;
  }  

  obtenerAdRazSocial(terminoAD :string = ''){
    if (terminoAD != null && terminoAD != ''){
      let terminoAD1 = terminoAD.toLowerCase();                   
      for( let a of this.adquirentesArr){
        let raz = a.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(terminoAD1)  >= 0){
          this.idAdq = a.idEmpresa;
          this.DTOFiltrosDesembolso.IdAd = a.idEmpresa;
        }
      }
    }
  }

  ListadoDesembolsoFiltro(){
    this.loading = true;
    if (this.ruc.value == null || this.ruc.value == ""){
        this.idProv = "";
        this.DTOFiltrosDesembolso.IdProv = ""}
    if (this.rucAdq.value == null || this.rucAdq.value == ""){
        this.idAdq="";
        this.DTOFiltrosDesembolso.IdAd="";
    }    
    if(this.DTOFiltrosDesembolso.Tipo == 524){
      this.activador = 524;
    }else{
      this.activador = 525;
    }
    console.log(this.activador);
    this.desembolsoService.FiltroListadoDesembolso(this.DTOFiltrosDesembolso,this.datePipe.transform(this.fechaD,'yyyy-MM-dd'),this.datePipe.transform(this.fechaH,'yyy-MM-dd')).
    subscribe(
      res =>{
          this.data = [];
          let Lista : any = res;
          let rows = [];
          Lista.map(array =>{array.checked = false});
          Lista.forEach(objet => {
            let b = this.data.filter(object => object.idDesembolso == objet.idDesembolso);
            if (b.length === 0){
              this.data.push(objet); 
            }
          });
            
          this.data.forEach(elemento => {
            let element : any = Lista.filter(elem => elem !== undefined && elem.idDesembolso === elemento.idDesembolso)
            rows.push(elemento, { detailRow: true,element })
            }
          );

          this.dataSource = new MatTableDataSource(rows);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;

          this.loading = false;
      },err =>{
        
        Swal.fire({
          title: "Registrar tipo de cambio",
          text: "Coordinar con el área de contabilidad",
            allowOutsideClick: true,
            heightAuto: false 
        });
        this.loading = false;
      }
    )
  }

  enviarIdDesembolso(idDesembolso:any){
      this.idDesembolso = idDesembolso;      
      this.flagDesembolsoDetalle = true;
  }

  MetcerrarDesembolsoDetalle(){
    this.ListadoDesembolsoFiltro();
    this.flagDesembolsoDetalle = false;
  }

  darBajaDesembolso(idDesembolso){
      Swal.fire({
          title:'',
          text:'¿Estás seguro en dar de baja la planilla?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText:'Si,dar de baja.',
          cancelButtonText: 'No,Cancelar.',
          reverseButtons: true,
          heightAuto: false
      }).then((result)=>{
          if(result.value){
            Swal.fire({
              title: '¡Espere!',
              html: 'Procesando solicitud.'
            })
            Swal.showLoading();
            this.form = new FormGroup({
              'idDesembolso' : new FormControl(idDesembolso),
              'Estado' : new FormControl('B'),
              'Baja_Usuario': new FormControl(this.user.Usuario) 
            })
              this.actualizarEstado(idDesembolso)
              this.desembolsoService.bajaEstadoDesembolso(this.form.getRawValue())
              .subscribe(res=>{
                Swal.fire({
                  title: '¡Documento dado de baja',
                  text: 'El documento fue dado de baja exitosamente.',
                  type: 'success',
                  heightAuto: false
                }).then(resp =>{
                  if(resp.value == true){
                    this.ListadoDesembolsoFiltro();
                  }
                });
              },
              err => {
                Swal.fire({
                  title: "Error",
                  text: "No se pudo dar de baja la planilla.",
                  type: "error",
                  allowOutsideClick: false,
                  heightAuto: false
                });
              })
          }else if(result.dismiss == Swal.DismissReason.cancel){
            this.loading = false;
          }
      })
  } 

  aprobarDesembolso(idDesembolso){
      let botones = '<button type="button" class="btn btn-default btn-md" style="background-color:#36af37" id="BCP">APROBAR</button>';
        botones = '<button type="button" class="btn btn-danger btn-md" id="cerrarSwal">Cancelar</button>';
        

    Swal.fire({
      title: '¿Está seguro de aprobar la planilla Nro. '+idDesembolso+'?',
      html: "Se notificará al cliente por E-mail.",
      type: 'success',
      showConfirmButton: true,
      focusConfirm: true,
      confirmButtonColor: '#36af37',
      confirmButtonText: 'APROBAR',
      footer:botones,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        this.fnAprobarDesembolso(idDesembolso,"BCP");
      } 
    });

    $(document).on('click', '#cerrarSwal', function(e) {
      e.preventDefault();
      Swal.close();
    });
  }

   fnAprobarDesembolso(idDesembolso,banco){
    Swal.fire({
      title: '¡Espere!',
      html: 'Procesando solicitud.',
      heightAuto: false
    })
    Swal.showLoading();
    this.form = new FormGroup({
      'idDesembolso' : new FormControl(idDesembolso),
      'Estado' : new FormControl('A')
    });
    this.desembolsoService.aprobarEstadoDesembolso(this.form.getRawValue()).subscribe(
    res =>{
      this.desembolsoService.downloadTXTPlanillaDesembolso(idDesembolso).subscribe(
        resp=>{
          this.showNotification('success','top','right','Se ha enviado un correo de aviso por la planilla '+idDesembolso+'.');
        },err=>{
          let error ="";
          error = err.error.error;
          this.showNotification('warning','top','right','No se logró enviar el correo. \n Error: ' + error);
        }
      )
      Swal.fire({
        title: '¡Planilla aprobada!',
        text: 'La planilla de desembolso ha sido aprobada.',
        type: 'success',
        heightAuto: false
      }).then(respu =>{
        if(respu.value == true){          
          this.ListadoDesembolsoFiltro();
        }
      });
    },
    err =>{
      Swal.fire({
        title: "Error",
        text: "No se pudo aprobar la planilla seleccionada.",
        type: "error",
        allowOutsideClick: false,
        heightAuto: false
      });
    })
  }
 
  obtenerpdf($file:any){
    window.open($file,"_blank");
  }
  
  actualizarEstado(idDesembolso){
      let ane:any;
      let contr :number = 0;
      let body: any = {"Estado":"P"};
      this.desembolsoService.obtenerDesembolsoCab(idDesembolso).subscribe(
        res=>{
          ane = res;
        if(ane[0]['Tipo_de_planilla'] == 524){
          for(let item of ane){
            contr +=1
            this.solicitudDesembolsoService.actualizarSoliDes(body,item.idSolicitudDesembolso).subscribe(
              resp=>{
                if(contr <= 2){
                  this.showNotification('success','top','right','La solicitud desembolso N° '+item.idSolicitudDesembolso+' ha regresado al estado pendiente.');
                }else if( contr > 2){
                  this.showNotification('success','top','right', contr + 'solicitud desembolso asociados han sido liberados' )
                }
              }, err=>{
                let error ="";
                error = err.error.error;
                this.showNotification('warning','top','right','La solicitud desembolso. '+item.idSolicitudDesembolso+' no han sido actualizado. \n Error: ' + error);
              }
            )
          }
        }
        }
      )
  }

  

  showNotification(type,from,align,message){
    $.notify({
        icon: "notifications",
        message: message
    },{
        type: type,
        timer: 4000,
        placement: {
            from: from,
            align: align
        },
        template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
          '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
          '<i class="material-icons" data-notify="icon">notifications</i> ' +
          '<span data-notify="title">{1}</span> ' +
          '<span data-notify="message">{2}</span>' +
          '<div class="progress" data-notify="progressbar">' +
            '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
          '</div>' +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }
}